import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";
import {StorageService} from "./storage.service";

const API_URL = environment.apiUrl + 'users/';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  changePassword(oldPassword: string, newPassword: string, userId: string): Observable<any> {
    return this.http.put(API_URL + userId + '/password', {
      oldPassword,
      newPassword
    });
  }

  getUsers(): Observable<any> {
    return this.http.get(API_URL);
  }

  updateUser(id: string, user: any): Observable<any> {
    return this.http.put(API_URL + id, user);
  }

  isAdmin() {
    const user = this.storageService.getUser();
    return user.roles.includes('ROLE_ADMIN');
  }

  getCustomerId(): number {
    const user = this.storageService.getUser();
    return user.customerId;
  }

}
